import GoogleAnalyticsEvent from "dataTransferObjects/googleAnalyticsEvent";
import PlanInformationLead from "./planInformationLead";

/* This class represents a lead of type More Information for a basic plan. */
export default class PlanInformationLeadBasic extends PlanInformationLead {
    constructor(formData) {
      super(formData);
      this.type = 'postPlanBrochureBasic';
      this.xxTrustedFormCertUrl = formData.xxTrustedFormCertUrl;
    }

    static getLeadSubmitedAnalyticsData() {
      return new GoogleAnalyticsEvent("TDV Events", "Direct Leads", "Search-CTA-Learn-More")
    }
  }
  